export const pathQueryParams = {
  initialTabName: 'initialTabName',
  currentTab: 'currentTab',
  loginByAuth0: 'login-by-auth0',
  // filters
  startDate: 'startDate',
  endDate: 'endDate',
} as const;
